import React, { useEffect } from 'react'
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider, Switch, Menu, TableCell, Typography, Tooltip, withStyles, Paper } from "@material-ui/core";
import { useSelector, useDispatch } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import DetailPoliklinik from './detaiPoli';
import AddSpesialis from './addSpesialis';
import api from '../api';
import filterIcon from '../../assets/ic_search@3x.png';
import Loader from 'react-loader-spinner'
import { useHistory } from 'react-router-dom';
import ic_detail from '../../assets/ic_detail.png';
import CloseImage from '../../assets/ic_close.png';


const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions()
const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 22,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const style = {
    position: "sticky",
    zIndex: 110
};

export default function Akun(props) {
    const history = useHistory()
    const [listAkun, setListAkun] = React.useState([])
    const [detailAkun, setDetailAkun] = React.useState([])
    const [statusMessage, setMessageStatus] = React.useState("")
    const [id, setID] = React.useState("")
    const [position, setPosition] = React.useState({})
    const [loading, setLoading] = React.useState(false)
    const [visibleAction, setVisibleAction] = React.useState(false)
    const [visibleDetail, setVisibleDetail] = React.useState(false)
    const [visibleCreate, setVisibleCreate] = React.useState(false)
    const [visibleStatus, setVisibleStatus] = React.useState(false)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const [create, setCreate] = React.useState(false);
    const [read, setRead] = React.useState(false);
    const [update, setUpdate] = React.useState(false);
    const [deleted, setDeleted] = React.useState(false);
    const ITEM_HEIGHT = 48;

    const forceUpdate = React.useReducer(bool => !bool)[1];

    React.useEffect(() => {
        props.setShowNotif(true)
        getAkun()
        getPermission(props)
        setLoading(true)
    }, [])

    const getPermission = (e) => {
        api.create().getPermission(e.menuid).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setCreate(data.create)
                    setUpdate(data.update)
                    setRead(data.read)
                    setDeleted(data.delete)
                }
            }
        })
    }

    const handleSeeDetail = ({ rowData }) => {
        console.log(rowData);
        const id = rowData[1]
        api.create().detailAkun(id).then(response => {
            let data;
            console.log(response);
            data = response.data.data
            history.push({
                pathname: "/masterdata/detail-akun",
                name: "Detail Akun",
                state: {
                    data,
                    id: rowData[1]
                }
            })
        })
    }

    const onClose = () => {
        setVisibleDetail(false)
        setVisibleCreate(false)
    }
    const getAkun = () => {
        api.create().getAkun().then(response => {
            console.log(response)
            if (response.data) {
                let temp = []
                response.data.data.map((el, idx) => {
                    el["No"] = idx + 1
                    if (el.status === 1) {
                        el.status = "Terverifikasi"
                    } else {
                        el.status = "Belum Terverifikasi"
                    }
                    temp.push(el)
                })
                setListAkun(temp)
                setLoading(false)
            } else {
                setLoading(false)
            }
        })
    }

    const handleClickMenu = (event) => {
        console.log(event);
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleStatus = ({ rowData }) => {
        // setVisibleStatus(true)
        setID(rowData[1])
        setDetailAkun(rowData[7])
        if (detailAkun === null) {
            setMessageStatus('Anda yakin non-aktif akun ini?')
            forceUpdate()
            setVisibleStatus(true)
        } else if (detailAkun !== null) {
            setMessageStatus('Anda yakin aktifin akun ini?')
            forceUpdate()
            setVisibleStatus(true)
        }

    }
    console.log(listAkun);

    const columns = [{
        name: "No",
        options: {
            filter: false,
            sort: true,
            sortThirdClickReset: true,
            // customHeadRender: (columnMeta) => (
            //     <TableCell style={{ width: 100 }}>
            //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
            //     </TableCell>
            // ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    },
    {
        name: "id",
        label: "ID Akun",
        options: {
            sort: true,
            sortThirdClickReset: true
        }
    },
    {
        name: "name",
        label: "Nama Pemilik Akun",
        options: {
            sort: true,
            sortThirdClickReset: true
        }
    },
    {
        name: "phone",
        label: "No. Handphone",
        options: {
            sort: true,
            sortThirdClickReset: true
        }
    },
    {
        name: "last_login",
        label: "Login Terakhir",
        options: {
            sort: true,
            sortThirdClickReset: true
        }
    },
    {
        name: "status",
        label: "Status",
        options: {
            sort: true,
            sortThirdClickReset: true,
            customBodyRender: (val, tableMeta) => {
                return (
                    <Typography style={{ color: val === "Terverifikasi" ? "green" : "red" }}>{val}</Typography>
                )
            }
        }
    },
    {
        name: "Aksi",
        options: {
            filter: false,
            sort: false,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, backgroundColor: 'white', }}>
                    <Typography style={{ textAlign: 'center', fontWeight: 600 }}>{columnMeta.label}</Typography>
                </TableCell>
            ),
            // customHeadRender: (columnMeta) => (
            //     <TableCell style={{ ...style, top: 0, zIndex: 110, backgroundColor: 'white', }}>
            //         <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
            //     </TableCell>
            // ),
            customBodyRender: (val, tableMeta) => {
                // console.log(tableMeta)
                return (
                    <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                        {update && (
                            <LightTooltip title={"Detail"} arrow>
                                <button
                                    style={{
                                        backgroundColor: "transparent",
                                        fontSize: 20,
                                        outline: 'none',
                                        borderColor: 'transparent',
                                        marginRight: 20
                                    }
                                    }
                                    onClick={() => handleSeeDetail(tableMeta)}
                                >
                                    <img src={ic_detail} style={{ width: 32, height: 32 }} />
                                </button>
                            </LightTooltip>
                        )}
                        {deleted && (
                            <LightTooltip title={`${tableMeta.rowData[7] === null ? "Active" : "Inactive"}`} arrow>
                                <button style={{
                                    backgroundColor: "transparent",
                                    fontSize: 20,
                                    outline: 'none',
                                    borderColor: 'transparent'
                                }}
                                    onClick={() => handleStatus(tableMeta)}>
                                    <IconSwitch checked={tableMeta.rowData[7] === null ? true : false} />
                                </button>
                            </LightTooltip>
                        )}
                    </div>
                )
            }
        }
    },
    {
        name: "deleted_at",
        options: {
            display: false,
            filter: false
        }
    }
    ];

    const options = {
        filterType: 'multiselect',
        fixedHeader: true,
        filter: true,
        search: true,
        sort: true,
        print: false,
        download: false,
        selectableRows: false,
        viewColumns: false,
        rowsPerPage: 10,
        responsive: 'scrollMaxHeight',

    };

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 110, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    const handleEdit = (e) => {
        console.log(e);
    };

    const handleSubmit = () => {
        if (detailAkun === null) {
            let formData = new FormData()
            formData.append('id', id)
            formData.append('activeinactive', 0)
            api.create().editAkun(formData).then(response => {
                console.log(response);
                if (response.data.message === "Success!") {
                    forceUpdate()
                    getAkun()
                }
            })
        } else {
            let formData = new FormData()
            formData.append('id', id)
            formData.append('activeinactive', 1)
            api.create().editAkun(formData).then(response => {
                console.log(response);
                if (response.data.message === "Success!") {
                    forceUpdate()
                    getAkun()
                }
            })
        }
        setVisibleStatus(false)
    }

    return (
        <div style={{ paddingTop: 10, position: 'relative' }}>
            {loading ? loadingComponent : null}
            {read && (
                <div >
                    {/* <div style={{ marginTop: 20, boxShadow: '5px 2px 10px 0 #999999', borderRadius: 30 }}> */}
                    <MuiThemeProvider theme={getMuiTheme()}>
                        {/* {listAkun && listAkun.map(el => {
                        
                        el.status === "Terverifikasi" ? 
                    })} */}
                        <MUIDataTable
                            data={listAkun}
                            columns={columns}
                            options={options}
                        />
                    </MuiThemeProvider>
                </div>
            )}
            {
                visibleAction ?
                    <div>
                        <Paper style={{ position: 'absolute', borderRadius: 7, height: 160, width: 120, left: "86%", top: (position.y - 85) }}>
                            <div style={{ cursor: 'pointer', paddingTop: 10, paddingLeft: 10 }}>
                                <Typography style={{ color: "#278863" }} onClick={() => handleEdit()}>Edit</Typography>
                                <Typography style={{ marginTop: 5, color: "#278863" }}>Delete</Typography>
                                <Typography style={{ marginTop: 5, color: "#278863" }}>Cuti</Typography>
                                <Typography style={{ marginTop: 5, color: "#278863" }}>Ganti Dokter</Typography>
                                <Typography style={{ marginTop: 5, color: "#278863" }}>Terlambat</Typography>
                            </div>
                        </Paper>
                    </div>
                    : null
            }
            {
                visibleStatus ?
                    <div className="App app-popup-show">
                        <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                            <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                <div className="col-1" />
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => setVisibleStatus(false)}
                                    >
                                        <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                    </button>
                                </div>
                            </div>
                            <div style={{ padding: 20 }}>
                                <Typography style={{ textAlign: 'left', fontSize: 16 }}> {detailAkun === null ? "Anda Yakin Non-aktif akun ini?" : "Anda Yakin Aktifkan akun ini?"} </Typography>
                            </div>
                            <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                <div className="column-1" style={{ alignSelf: 'center' }}>
                                </div>
                                <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <div
                                        onClick={() => setVisibleStatus(false)}
                                        style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                        <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                    </div>
                                    <div
                                        onClick={() => handleSubmit()}
                                        style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
            }
            {/* {visibleDetail ?
                <DetailPoliklinik
                    onClose={onClose}
                    detail={detailPoli}
                />
                : null} */}
        </div>
    )

}